import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../../helpers';
import { INTAKE_QUESTIONNAIRES_API_BASE } from '../../constants';

import type { IEducation } from '../../../../../pages/common';
import type {
  SetIntakeNotAttendingSchoolPayload,
  UpdateIntakeEducationInfoPayload,
} from './types';

export function createIntakeEducationThunks() {
  return {
    updateIntakeEducationInfo: updateIntakeEducationInfo(),
    setIntakeNotAttendingSchool: setIntakeNotAttendingSchool(),
  };
}

function updateIntakeEducationInfo() {
  return createAsyncThunk<IEducation, UpdateIntakeEducationInfoPayload>(
    'intakeQuestionnaire/updateIntakeEducationInfo',
    async ({ intakeQuestionnaireId, data, getAccessTokenSilently }) =>
      fetchWrapper.patch(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/education_info`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function setIntakeNotAttendingSchool() {
  return createAsyncThunk<void, SetIntakeNotAttendingSchoolPayload>(
    'intakeQuestionnaire/setIntakeNotAttendingSchool',
    async ({ intakeQuestionnaireId, notAttendingSchool, getAccessTokenSilently }) => {
      await fetchWrapper.patch(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}`,
          getAccessTokenSilently,
        },
        { not_attending_school: notAttendingSchool },
      );
    },
  );
}
